import {
  SEND_EMAIL_INVITE_FAILURE,
  SEND_EMAIL_INVITE_SUCCESS,
} from '../actions';
import { SendEmailInviteRequest, Thunk } from './interfaces';

import callGraphQLApi from '@helpers/callGraphQLApi';

export interface SendEmailInviteResponse {
  sendEmail: boolean;
}
export const sendEmailInvite: Thunk<SendEmailInviteRequest, any> =
  ({ email, emailFromAddress, replyTo, subject, message }) =>
  async (dispatch, getState) => {
    const query = `mutation SendEmail(
      $emailFromAddress: String!
      $replyTo: String!
      $email: String!
      $subject: String!
      $message: String!
    ) {
      sendEmail (input: {
        from: $emailFromAddress,
        replyTo: $replyTo,
        to: $email,
        subject: $subject,
        message: $message,
      })
    }`;
    return await callGraphQLApi<SendEmailInviteResponse>({
      actionTypes: [
        'NOOP',
        SEND_EMAIL_INVITE_SUCCESS,
        SEND_EMAIL_INVITE_FAILURE,
      ],
      query,
      variables: {
        email,
        emailFromAddress,
        replyTo,
        subject,
        message,
      },
      dispatch,
      getState,
    });
  };
